import { createUniversalConnector } from "../../universal-connector-factory";
import { ComponentProps, StateProps, DispatchProps, ContainerProps } from "../props";
import { withSportsbookBetslipContext, type SportsbookBetslipContext } from "../../../context/sportsbook";
import { makeMapStateToProps, mapDispatchToProps } from "./map-to-props-factory";

const connector = createUniversalConnector<StateProps, DispatchProps, ContainerProps, ComponentProps>(
  makeMapStateToProps,
  mapDispatchToProps,
);

export default withSportsbookBetslipContext(({ capabilities }: SportsbookBetslipContext) => ({
  capabilities,
}))(connector);
